import Vue from 'vue'
const user = {
  state: {
    users: [],
    facilitators: []
  },

  getters: {
    users(state) {
      return state.users
    },
    facilitators(state) {
      return state.facilitators
    },
  },

  mutations: {
    getUsers(state, payload) {
      state.users = payload
    },
    getFacilitators(state, payload) {
      state.facilitators = payload
    },
  },

  actions: {
    getUsers(context, payload) {
      const url = 'Users';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getUsers', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    }, 
    getFacilitators(context, payload) {
      const url = 'Users/Facilitators';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getFacilitators', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    }, 
    getFilteredUsers(context, payload) {
      const url = 'UserSearch';
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.commit('getUsers', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    }, 
    updateUser(context, payload){
      const url = `Users/${ payload.UserID }`;
      Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('getUsers')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    saveUsers(context, payload) {
      payload.UserName = `${payload.Email}`
      const url = `User`
      Vue.prototype.$axios.post(url, payload).then(
        (res) => {
          context.dispatch('getUsers')
        },
        (error) => {
          console.log(error)
        }
      )
    },
  },
}

export default user
